import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'carriers',
  templateUrl: './carriers.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryCarriersComponent implements OnInit {
  @Input() data;
  @Output() dCarriersEmitter: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {}
  save() {
    this.dCarriersEmitter.emit({ status: 'forward', id: this.data.id });
  }

  back() {
    this.dCarriersEmitter.emit({ status: 'backward' });
  }
}
